<div class="modal-header bg-dark text-white">
  <h3 class="modal-title me-3">{{ showAllUsers ? 'Re-invite Contacts to This Tender' : 'Select Suppliers from Contacts' }}</h3>
  <div class="me-3">
    <input type="text" class="form-control" placeholder="Search by name, alias, or email..." [(ngModel)]="searchTerm"
      (ngModelChange)="onSearchChange()" />
  </div>
  <div class="me-3">
    <ng-select [placeholder]="'Filter suppliers by tags:'" [items]="tags" multiple="true" bindLabel="name"
      (ngModelChange)="tagChange($event)" [(ngModel)]="selectedTags">
    </ng-select>
  </div>
  <div class="ms-auto" data-bs-theme="dark">
    <a (click)="close()" aria-label="Close" class="btn-close" href="javascript:void(0);">
    </a>
  </div>
</div>
<div class="modal-body p-0">

  <div class="alert alert-info small rounded-0 border-0 border-bottom mb-0 px-3 py-2">
    <ng-container *ngIf="showAllUsers; else addModeExplanation">
      Each contact you select is emailed about this tender straight away. Contacts who have not activated
      their JetFuelTenders account yet receive an account activation invitation; contacts who have receive a
      bidding invitation with the tender details. Suppliers already bidding keep their existing bids &mdash;
      nothing is reset.
    </ng-container>
    <ng-template #addModeExplanation>
      Contacts you select are added to this tender and emailed an invitation to bid.
    </ng-template>
  </div>

  <div class="d-flex flex-wrap justify-content-between align-items-center px-3 py-2 border-bottom small">
    <span class="text-muted">
      Available (current filters):
      <strong>{{ availableCompaniesCount }}</strong> companies ·
      <strong>{{ availableContactsCount }}</strong> contacts
    </span>
    <span class="text-primary">
      Selected:
      <strong>{{ selectedCompaniesCount }}</strong> companies ·
      <strong>{{ selectedContactsCount }}</strong> contacts
    </span>
  </div>

  <table *ngIf="filteredSupplierUsers.length" class="table m-0">
    <thead class="border-bottom">
      <tr>
        <th class="border-top-0 th-40">
          <input type="checkbox" [checked]="allVisibleSelected" (change)="toggleSelectAll($event)"
            title="Select all suppliers in this list (ignores the search box)">
        </th>
        <th class="border-top-0">Company</th>
        <th class="border-top-0">Employee</th>
        <th class="border-top-0">Email</th>
        <th class="border-top-0">Tags</th>
        <th class="border-top-0"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let supplier of filteredSupplierUsers">
        <td>
          <input (change)="onChangeSupplier(supplier, $event)" type="checkbox" [checked]="isSupplierSelected(supplier)"
            value="{{supplier.company.id}}">
        </td>
        <td>
            <div class="d-flex align-items-center">
          <div *ngIf="supplier.company.logo" class="avatar avatar-48 bg-white me-3">
            <img class="p-2" src="{{ supplier.company.logo }}" alt="{{ supplier.company.name }}">
          </div>
            </div>
          {{ supplier.company.name}} <span *ngIf="supplier.supplierAlias"
            class="text-muted">({{supplier.supplierAlias}})</span>
        </td>
        <td>
          {{supplier.lastName}}, {{supplier.firstName}}
        </td>
        <td>
          {{supplier.email}}
        </td>
        <td>
          <span *ngFor="let tag of supplier.tags">
            <span
              class="badge py-1 px-2 me-3 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill"
              (click)="clickTag(tag)">{{tag['name']}}
            </span>
          </span>
        </td>
        <td>
          <a href="javascript:void(0);" class="btn btn-sm btn-outline-primary" (click)="addContact(supplier)">Add
            Contact</a>
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="!filteredSupplierUsers.length">
    <div class="my-5 text-center small">
      No contacts to display
    </div>
  </div>
</div>
<div class="modal-footer bg-white border-top-0">
  <jft-submit-button (onClick)="addSelected()" [class]="'btn btn-outline-primary'" [loading]="loading"
    [disabled]="loading" [title]="'Add Selected'">
  </jft-submit-button>
  <jft-submit-button *ngIf="allSuppliersButton" (onClick)="addAllSuppliers()" [loading]="loading" [disabled]="loading"
    [class]="'btn btn-outline-primary'" [title]="'Add All Suppliers'">
  </jft-submit-button>
  <button (click)="close()" class="btn btn-light">Close</button>
</div>
